/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Building version information - represents a single version in the building\'s history
 */
export interface BuildingVersionDto { 
    /**
     * End date when this version ceased to be valid (null if currently valid)
     */
    endDate?: string;
    /**
     * Unique identifier of this building version
     */
    id?: number;
    /**
     * Start date when this version became valid
     */
    startDate?: string;
}

